import { createFileRoute, notFound } from "@tanstack/react-router";
import { isApiError } from "@/api/client";
import { opportunityQueryOptions } from "@/api/queries/opportunities";
import { NotFound } from "@/components/feedback/not-found";
import { OpportunityDetailPage } from "@/features/opportunity-detail/opportunity-detail-page";

export const Route = createFileRoute("/_authenticated/$store/opportunities/$opportunityId")({
  loader: async ({ context, params }) => {
    try {
      await context.queryClient.ensureQueryData(opportunityQueryOptions(params.opportunityId));
    } catch (err) {
      // 404 and 403 look the same to the user: no record they can see.
      if (isApiError(err) && (err.isNotFound || err.isForbidden)) throw notFound();
      throw err;
    }
  },
  notFoundComponent: () => <NotFound title="Opportunity not found" description="It may have been removed, or it belongs to a store you can't access." />,
  head: () => ({ meta: [{ title: "Opportunity · Rogue AI" }] }),
  component: OpportunityDetailPage,
});
